import { Link, NavLink } from "react-router-dom";
import { Search } from "lucide-react";
import { SECTIONS } from "@/lib/sections";

const today = new Date().toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

const navCls = ({ isActive }) =>
  `font-ui text-[13px] tracking-wide py-3 border-b-2 transition-colors duration-200 ${
    isActive ? "border-[var(--accent)] text-[var(--ink)]" : "border-transparent text-[var(--ink-2)] hover:text-[var(--accent)]"
  }`;

export const Masthead = () => (
  <header className="sticky top-0 z-40 bg-[#FBFBFA]/95 backdrop-blur-md border-b border-[var(--rule)]">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <div className="flex items-end justify-between pt-6 pb-4 border-b border-[var(--ink)]">
        <Link to="/" data-testid="masthead-logo-link" className="font-display text-3xl sm:text-4xl font-bold tracking-tight leading-none">
          uk<span className="italic font-medium">discovered</span>
        </Link>
        <span className="hidden sm:block meta !tracking-[0.12em]" data-testid="masthead-date">{today}</span>
      </div>
      <nav className="flex items-center gap-6 sm:gap-8 overflow-x-auto" data-testid="masthead-nav">
        {SECTIONS.map((s) => (
          <NavLink key={s.slug} to={`/section/${s.slug}`} className={navCls} data-testid={`nav-link-${s.slug}`}>
            {s.name}
          </NavLink>
        ))}
        <NavLink to="/series" className={navCls} data-testid="nav-link-series">Series</NavLink>
        <NavLink to="/about" className={navCls} data-testid="nav-link-about">About</NavLink>
        <NavLink to="/contact" className={navCls} data-testid="nav-link-contact">Contact</NavLink>
        <NavLink to="/search" className={(p) => `${navCls(p)} ml-auto flex items-center gap-1.5`} data-testid="nav-link-search">
          <Search size={14} strokeWidth={1.75} /> <span className="hidden sm:inline">Search</span>
        </NavLink>
      </nav>
    </div>
  </header>
);
